'use strict';

module.exports = {
    closeAlertCookies: function () {
        $(".checkout-alert-register-card-close").on("click", function () {
            $(".blockSession").css("display", "none");
        })
    }
}